import { defineMessages } from '@sm/intl';

export default defineMessages({
  MODAL_TITLE_PENDING: {
    id: 'SeatRequestCopy.RequestPending',
    defaultMessage: 'Request pending',
    description: '[Type: Header][Vis: med] - Team invite request pending',
  },
  MODAL_TITLE_AVAILABLE: {
    id: 'SeatRequestCopy.RequestAvailable',
    defaultMessage: 'Request Power seat',
    description: '[Type: Header][Vis: med] - Team invite request pending',
  },
  MODAL_TITLE_NOT_AVAILABLE: {
    id: 'SeatRequestCopy.RequestUnavailable',
    defaultMessage: 'Request Unavailable',
    description: '[Type: Header][Vis: med] - Team invite request pending',
  },
  REQUEST_DESC_1: {
    id: 'SeatRequestCopy.RequestDesc1',
    defaultMessage: 'You have a Casual seat',
    description: '[Type: Header][Vis: med] - Team invite request pending',
  },
  REQUEST_DESC_2: {
    id: 'SeatRequestCopy.RequestDesc2',
    defaultMessage:
      'To unlock features like unlimited questions, logic, and exporting results, request a Power seat. <span id="help-link">Compare features</span>',
    description:
      '[Type: Label][Vis: med] - Team invite request empty state message',
  },
  REQUEST_DESC_2_ALLOW_EXPORT: {
    id: 'SeatRequestCopy.RequestDesc2AllowExport',
    defaultMessage:
      'To collaborate with Power Users, and unlock features like unlimited questions and logic, request a Power seat. <span id="help-link">Compare features</span>',
    description:
      '[Type: Label][Vis: med] - Team invite request empty state message if Casual is allowed to export',
  },
  REASON_LABEL: {
    id: 'SeatRequestCopy.ReasonLabel',
    defaultMessage: 'Message to your admin (optional)',
    description:
      '[Type: Label][Vis: med] - label next to text box for users to specify a reason for their request',
  },
  PENDING_DESC_1: {
    id: 'SeatRequestCopy.PendingDesc1',
    defaultMessage: 'Request sent: {date}',
    description:
      '[Type: Label][Vis: med] - field describing when a request was sent',
  },
  PENDING_DESC_2: {
    id: 'SeatRequestCopy.PendingDesc2',
    defaultMessage:
      'Your Power seat request is pending admin review. If you need it soon, send your admin a reminder. If you no longer need it, you can cancel your request.',
    description:
      '[Type: Label][Vis: med] - Team invite request empty state message',
  },
  PENDING_DESC_3: {
    id: 'SeatRequestCopy.PendingDesc3',
    defaultMessage: 'Primary Admin: <span id="email"></span>',
    description:
      '[Type: Label][Vis: med] - Team invite request empty state message',
  },
  NOT_AVAILABLE_DESC_1: {
    id: 'SeatRequestCopy.NotAvailableDesc1',
    defaultMessage: 'Seat upgrade is not available for your account.',
    description: '[Type: Paragraph][Vis: med] - ',
  },
  NOT_AVAILABLE_DESC_2: {
    id: 'SeatRequestCopy.NotAvailableDesc2',
    defaultMessage:
      'Please contact your primary admin: <span id="email"></span>',
    description: '[Type: Paragraph][Vis: med] - ',
  },
  SEND_BUTTON: {
    id: 'SeatRequestCopy.SendButton',
    defaultMessage: 'Send request',
    description: '[Type: Label][Vis: high] - Button label for sending request',
  },
  CANCEL_BUTTON: {
    id: 'SeatRequestCopy.CancelButton',
    defaultMessage: 'Cancel',
    description:
      '[Type: Label][Vis: med] - Button label for close request modal dialog',
  },
  CANCEL_REQUEST_BUTTON: {
    id: 'SeatRequestCopy.CancelRequestButton',
    defaultMessage: 'Cancel Request',
    description:
      '[Type: Label][Vis: med] - Button label for cancelling request',
  },
  SEND_REMINDER_BUTTON: {
    id: 'SeatRequestCopy.SendReminderButton',
    defaultMessage: 'Send Reminder',
    description: '[Type: Button][Vis: med] - Button label to send a reminder.',
  },
  CLOSE_BUTTON: {
    id: 'SeatRequestCopy.CloseButton',
    defaultMessage: 'Close',
    description: '[Type: Button][Vis: med] - Button label to send a reminder.',
  },
  TOAST_REQUEST_SENT: {
    id: 'SeatRequestCopy.ToastRequestSent',
    defaultMessage: 'Request sent',
    description: '[Type: Toast][Vis: low] - request success toast',
  },
  TOAST_REQUEST_CANCELED: {
    id: 'SeatRequestCopy.ToastRequestCanceled',
    defaultMessage: 'Request canceled',
    description: '[Type: Toast][Vis: low] - request success cancelled toast',
  },
  TOAST_REMINDER_SENT: {
    id: 'SeatRequestCopy.ToastReminderSent',
    defaultMessage: 'Reminder sent',
    description:
      '[Type: Toast][Vis: low] - request reminder sent successfully toast',
  },
  TOAST_ERROR: {
    id: 'SeatRequestCopy.ToastError',
    defaultMessage: 'Request error - refresh the page and try again',
    description: '[Type: Toast][Vis: low] - request failed error toast',
  },
});
